/* istanbul ignore next */
import { createUseStyles } from '@glu/theming';

const styles = {
  logo: {
    maxHeight: '100%',
    maxWidth: '100%'
  },
  // TODO - CB-48476 - remove link class after @glu/nav-react is upgraded to enable focus on tab
  link: {
    display: 'contents'
  }
};

export default createUseStyles(styles);
